module.exports = "/_next/static/images/a8028ad17e85e8a35136852358ce268c-nubank-outdoor-lg@1x.jpg";